/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SponsorsSection_query = {
    readonly viewer: {
        readonly emails: ReadonlyArray<{
            readonly email: string | null;
            readonly verified: boolean | null;
        } | null>;
    } | null;
    readonly " $refType": "SponsorsSection_query";
};
export type SponsorsSection_query$data = SponsorsSection_query;
export type SponsorsSection_query$key = {
    readonly " $data"?: SponsorsSection_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SponsorsSection_query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SponsorsSection_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEmail",
          "kind": "LinkedField",
          "name": "emails",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "verified",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '7854f4b48a2e028ad021b317ad49814a';
export default node;
